import React from 'react';
import { Box, FormLabel } from '@mui/material';

export function MoFieldLabel({
  label,
  htmlFor,
  error,
  action,
}: {
  label: string;
  htmlFor: string;
  error?: boolean;
  action?: React.ReactNode;
}) {
  if (!action) {
    return (
      <FormLabel htmlFor={htmlFor} error={error}>
        {label}
      </FormLabel>
    );
  }
  return (
    <Box
      display="flex"
      flexWrap="wrap"
      alignItems="center"
      justifyContent="space-between"
      columnGap={2}
      rowGap={1}
      mb={1}
    >
      <FormLabel htmlFor={htmlFor} error={error} sx={{ mb: 0 }}>
        {label}
      </FormLabel>
      {action}
    </Box>
  );
}
